import * as types from 'misc/types';
import * as actions from 'misc/actions';

const popup = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.POPUP_SHOW:
            return actions.save(state, action.payload);
        case types.POPUP_HIDE_BANKID:
            // Just set showBankIdMenu to false, keep old data 
            return actions.save(state, {
                ...state.data,
                ...action.payload,
                showBankIdMenu: false
            });
        case types.POPUP_HIDE:
            return actions.save(state, action.payload);
        default:
            return state;
    }
};

export default popup;



// WEBPACK FOOTER //
// ./src/reducers/popup.js